import { TodoNotification as TodoNotificationType } from '../../types'
import { BaseNotificationItem } from '../../BaseNotificationItem'
import Styles from '../../NotificationItem.module.scss'
import { ReactComponent as TaskIcon } from 'common/PropertyItem/icons/tasks__16.svg'
import { titleForTodoType, pathForTodoNotification } from './utils'
import { useAuth } from 'hooks/UseAuth'

interface Props {
  notification: TodoNotificationType
  onClose: () => void
}

export const TodoNotification = ({ notification, onClose }: Props) => {
  const auth = useAuth()
  const assignedToMe = auth?.id === notification.subject.assignee_id

  return (
    <BaseNotificationItem
      notification={notification}
      onClose={onClose}
      title={titleForTodoType(notification.subject.subject_type, assignedToMe)}
      icon={<TaskIcon role="img" title="Todo Icon" className={Styles.icon} />}
      path={pathForTodoNotification(notification)}
      aria-label="Todo Notification"
    />
  )
}
